module.exports = __webpack_public_path__ + "static/media/WebsiteRightPanel.60daae90.svg";